const PreClaimsTypes = {
  CREATE_CLAIM_PROGRESS: 'PRE_CLAIMS.CREATE_CLAIM_PROGRESS',

  GET_CLAIM_DUPLICATES_PROGRESS: 'PRE_CLAIMS.GET_CLAIM_DUPLICATES_PROGRESS',
  GET_CLAIM_DUPLICATES_SUCCESS: 'PRE_CLAIMS.GET_CLAIM_DUPLICATES_SUCCESS',
  GET_CLAIM_DUPLICATES_ERROR: 'PRE_CLAIMS.GET_CLAIM_DUPLICATES_ERROR',
};

export default PreClaimsTypes;
